import { render, staticRenderFns } from "./chooseAccept.vue?vue&type=template&id=702ffcca&"
import script from "./chooseAccept.vue?vue&type=script&lang=js&"
export * from "./chooseAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports